import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Stack, Typography } from "@mui/material";
import HealthMeasurementGauge from "@/features/MyHealth/components/HealthMeasurementGauge";
import {
  getHealthMeasurementValueRange,
  type HealthMeasurementQuestionType,
} from "@/services/core-api-adapter";
import { HealthMeasurementIdentifier } from "@/store";
import { getHealthMeasurementValueRangeColors } from "@/theme";

const DIASTOLIC_NUMBER_OF_TICKS = 76;

function getValueRangeWithColors() {
  const valueRange = getHealthMeasurementValueRange("DiastolicBloodPressure");
  const colorMap = getHealthMeasurementValueRangeColors() as Record<
    string,
    Record<string, string>
  >;
  const key: HealthMeasurementQuestionType = "DiastolicBloodPressure";
  return valueRange.map((item) => ({
    ...item,
    color: colorMap[key]?.[item.healthRiskIndicator],
  }));
}

export interface CurrentDiastolicBPProps {
  value: number;
  unit?: string;
}

export default function CurrentDiastolicBP({
  value,
  unit = "",
}: CurrentDiastolicBPProps) {
  const { t } = useTranslation();
  const valueRange = useMemo(() => getValueRangeWithColors(), []);

  return (
    <Stack alignItems="center">
      <HealthMeasurementGauge
        healthMeasurementIdentifier={HealthMeasurementIdentifier.BloodPressure}
        value={value}
        unit={unit}
        valueRange={valueRange}
        numberOfTicks={DIASTOLIC_NUMBER_OF_TICKS}
      />
      <Typography
        sx={{
          fontWeight: 600,
          fontSize: 16,
          lineHeight: 1.25,
        }}
      >
        {t("HealthProfile.DiastolicBloodPressure.detail.gauge.title")}
      </Typography>
    </Stack>
  );
}
